var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Android",
    transform: "translate(-353 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10682",
    "data-name": "Rectangle 10682",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(353 579)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "android-2",
    "data-name": "android",
    transform: "translate(363.099 587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_8",
    "data-name": "Exclusion 8",
    d: "M12.339,23.7a1.482,1.482,0,0,1-1.48-1.48V18.761H8.884v3.455a1.48,1.48,0,1,1-2.961,0v-3.5a2.477,2.477,0,0,1-1.975-2.418V8.4A.494.494,0,0,1,4.442,7.9H15.3a.494.494,0,0,1,.493.493v7.9a2.476,2.476,0,0,1-1.974,2.418v3.5A1.482,1.482,0,0,1,12.339,23.7Zm5.923-5.923a1.482,1.482,0,0,1-1.481-1.48V9.383a1.481,1.481,0,0,1,2.962,0v6.91A1.482,1.482,0,0,1,18.262,17.773Zm-16.782,0A1.482,1.482,0,0,1,0,16.293V9.383a1.481,1.481,0,0,1,2.962,0v6.91A1.482,1.482,0,0,1,1.48,17.773ZM15.3,6.916H4.442a.494.494,0,0,1-.493-.494,5.191,5.191,0,0,1,2.334-4.37l-1.2-1.2a.493.493,0,0,1,.7-.7l1.4,1.4a6.76,6.76,0,0,1,5.382,0l1.4-1.4.008-.009,0,0a.493.493,0,1,1,.686.71l-1.2,1.2a5.191,5.191,0,0,1,2.334,4.37A.494.494,0,0,1,15.3,6.916ZM12.339,3.954a.493.493,0,1,0,.493.493A.494.494,0,0,0,12.339,3.954Zm-4.935,0a.493.493,0,1,0,.493.493A.494.494,0,0,0,7.4,3.954Z",
    transform: "translate(0 0)",
    fill: "#23c95d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.37945723.svg";
export { ForwardRef as ReactComponent };